import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { environment } from './../../../../../environments/environment';
import { IsActive } from './../../../../model';

@Injectable()
export class EcallEditService {

  private urlPrefix: string = environment.appUrl;

  constructor(
    private http: HttpClient
  ) { }

  edit(ecallId, input): Observable<any> {
    const url = this.urlPrefix + 'e-calls/' + ecallId;
    return this.http
      .put(url, {
        creationTime: input.creationTime,
        receivedTime: input.receivedTime,
        arrivedTime: input.arrivedTime,
        completedTime: input.completedTime,
        status: input.status,
        remarks: input.remarks,
        contactPerson: input.contactPerson,
        contactNumber: input.contactNumber,
        siteId: input.siteId,
        teamIds: input.teamIds,
        equipList: input.equipList,
        userAssignModels: input.userAssignModels,
        customerReport: input.customerReport
      }, { observe: 'response' })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/ecall/ecall-edit/ecall-edit.service.ts